import type { SightmapComponent } from './schema.ts'
import type { DefinitionId } from '../../stable-surfaces/id.ts'
import { PAGE_ROOT_DEFINITION_ID } from '../../stable-surfaces/page-root-id.ts'

/** The page is the durable outermost component, including on maps with no named regions.
 * Shared by QA target resolution and Subtext export; never derived from a recording node ID. */
export const PAGE_ROOT_COMPONENT: SightmapComponent & { id: DefinitionId } = {
  id: PAGE_ROOT_DEFINITION_ID, name: 'Page content', selector: 'body', kind: 'component',
}
